module.exports = __webpack_public_path__ + "img/logoSeritec.5ecccf7e.png";